define('home/views/UserCardView',[
    'backbone-marionette',
    'home/mixins/withAllstarPopover',

    'home/templates/userCard',

    'core/bus',
], function (
    Marionette,
    withAllstarPopover,

    userCardTemplate,

    bus
) {
    'use strict';

    var UserCardView = Marionette.ItemView.extend({
        template: userCardTemplate,
        templateHelpers: function () {
            return {
                isSessionUser: this.model.isSessionUser(),
            };
        },
        className: 'card',

        events: {
            'click [data-action=toggle-follow]': 'toggleFollow',
        },
        modelEvents: {
            'change:isFollowing': 'handleFollowedClass',
        },

        handleFollowedClass: function () {
            this.$('[data-action=toggle-follow]').toggleClass('active', this.model.get('isFollowing'));
        },

        toggleFollow: function (evt) {
            if (evt)
                evt.preventDefault();

            // Because we haven't toggled the following state on the
            // user model yet, the expected state is the inverse of the current.
            if (this.model.get('isFollowing'))
                bus.trigger('uiAction:unfollowUser', this.model, evt);
            else
                bus.trigger('uiAction:followUser', this.model, evt);

            this.model.toggleFollowed();
        },
    });

    withAllstarPopover.call(UserCardView.prototype);

    return UserCardView;
});

